module.exports = __webpack_public_path__ + "img/8.8a1b3915.jpg";